import script from "./UserStatCards.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserStatCards.vue?vue&type=script&setup=true&lang=ts"

import "@/components/user/UserStatCards.css?vue&type=style&index=0&id=76e9ff54&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76e9ff54"]])

export default __exports__